// Submissions List Page Script - Type-Safe Version
import { publicPage } from '../lib/page-runtime';
import type { SubmissionCard } from '../types/api';

publicPage({
  init: async function() {
  let allSubmissions: SubmissionCard[] = [];
  let currentFilter = 'all';
  let currentSearch = '';
  let currentSort = 'newest';

  async function loadAllSubmissions() {
    const result = await window.SubmissionsPageData.loadSubmissions();
    if (!result.ok) {
      showError(result.error);
      return;
    }

    allSubmissions = result.data;
    updateStats(allSubmissions);
    renderSubmissions();
  }

  function renderSubmissions() {
    const listEl = document.getElementById('submissions-list');
    if (!listEl) return;

    const filtered = window.SubmissionsPageRenderers.filterSubmissions({
      submissions: allSubmissions,
      status: currentFilter,
      search: currentSearch,
      sort: currentSort,
    });
    listEl.innerHTML = window.SubmissionsPageRenderers.renderList(filtered);
  }

  function updateStats(submissions: SubmissionCard[]) {
    const stats = window.SubmissionsPageRenderers.submissionStats(submissions);
    const totalEl = document.getElementById('stat-total');
    const pendingEl = document.getElementById('stat-pending');
    const approvedEl = document.getElementById('stat-approved');
    const publishedEl = document.getElementById('stat-published');
    if (totalEl) totalEl.textContent = String(stats.total);
    if (pendingEl) pendingEl.textContent = String(stats.pending);
    if (approvedEl) approvedEl.textContent = String(stats.approved);
    if (publishedEl) publishedEl.textContent = String(stats.published);
  }

  function showError(message: string) {
    const listEl = document.getElementById('submissions-list');
    if (!listEl) return;

    listEl.innerHTML = window.SubmissionsPageRenderers.renderError(message);
  }

  // Event Listeners

  // Stat cards (clickable filters)
  document.querySelectorAll('.stat-card').forEach(card => {
    card.addEventListener('click', () => {
      const filter = (card as HTMLElement).dataset.filter;
      currentFilter = filter || 'all';

      // Update filter chips
      document.querySelectorAll('.filter-chip').forEach(chip => {
        chip.classList.toggle('active', (chip as HTMLElement).dataset.status === filter);
      });

      renderSubmissions();
    });
  });

  // Filter chips
  document.querySelectorAll('.filter-chip').forEach(chip => {
    chip.addEventListener('click', () => {
      currentFilter = (chip as HTMLElement).dataset.status || 'all';

      document.querySelectorAll('.filter-chip').forEach(c => {
        c.classList.remove('active');
      });
      chip.classList.add('active');

      renderSubmissions();
    });
  });

  // Search input
  const searchInput = document.getElementById('search-input');
  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      currentSearch = (e.target as HTMLInputElement).value.trim();
      renderSubmissions();
    });
  }

  // Sort select
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      currentSort = (e.target as HTMLSelectElement).value;
      renderSubmissions();
    });
  }

  // Initial load
  loadAllSubmissions();
  },
});
